import {formateData, headers} from "./index";
import {applicationName} from "../utils";
import request from "../base/request";
let host = "/cm-sites-pms/";

const Apis = {
    linkSourceAdd: host + "linkSource/add", //图片源新增
    linkSourceListInitDataSource: host + "linkSource/list",//图片源列表
    linkSourceUpdate:host+"linkSource/edit",//图片源修改
    linkSourceDelete:host+"linkSource/deleteById",//删除
    linkSourceGetById:host+"linkSource/getById"//删除
};

export const linkSourceAdd = (body, callBack) => {
    request({url: Apis.linkSourceAdd, contentType: "json", method: "post", body, callBack});
};
export const linkSourceListInitDataSource = (body, callBack)  => {
    request({url: Apis.linkSourceListInitDataSource, body, callBack});
};
export const linkSourceUpdate = (body, callBack) => {
    request({url: Apis.linkSourceUpdate, contentType: "json", method: "post", body, callBack});
};
export const linkSourceDelete = (body, callBack) => {
    request({url: Apis.linkSourceDelete, method: "post", body, callBack});
};
export const linkSourceGetById = (body, callBack) => {
    request({url: Apis.linkSourceGetById, body, callBack});
};
// export const linkSourceListInitDataSource = (start, size,mediaCode,treeId,treeContentId, callBack) => {
//     let url = "/cm-sites-" + applicationName() + "/linkSource/list?"+formateData({
//         start,size,mediaCode,treeId,treeContentId
//     });
//     fetch(url, {
//         method: 'get',
//         cache: 'no-cache',
//         headers: headers,
//         credentials: 'include'
//     }).then(response => response.json()).then(data => {
//         callBack(data);
//     }).catch((error) => {
//         console.error("actionError:linkSourceListInitDataSource",error);
//         callBack({});
//     })
// };
// export const linkSourceAdd = (linkSource, callBack) => {
//     let url = "/cm-sites-" + applicationName() + "/linkSource/add";
//     fetch(url, {
//         method: 'post',
//         cache: 'no-cache',
//         headers: headers,
//         credentials: 'include',
//         body: formateData(linkSource)
//     }).then(response => response.json()).then(data => {
//         callBack(data);
//     }).catch((error) => {
//         console.error("actionError:linkSourceListInitDataSource",error);
//         callBack({});
//     })
// };
// export const linkSourceUpdate = (linkSource, callBack) => {
//     let url = "/cm-sites-" + applicationName() + "/linkSource/edit";
//     fetch(url, {
//         method: 'post',
//         cache: 'no-cache',
//         headers: headers,
//         credentials: 'include',
//         body: formateData(linkSource)
//     }).then(response => response.json()).then(data => {
//         callBack(data);
//     }).catch((error) => {
//         console.error("actionError:linkSourceListInitDataSource",error);
//         callBack({});
//     })
// };
// export const linkSourceDelete = (id, callBack) => {
//     let url = "/cm-sites-" + applicationName() + "/linkSource/deleteById";
//     fetch(url, {
//         method: 'post',
//         cache: 'no-cache',
//         headers: headers,
//         credentials: 'include',
//         body: formateData(id)
//     }).then(response => response.json()).then(data => {
//         callBack(data);
//     }).catch((error) => {
//         console.error("actionError:linkSourceListInitDataSource",error);
//         callBack({});
//     })
// };
// export const linkSourceDeletes = (ids, callBack) => {
//     let url = "/cm-sites-" + applicationName() + "/linkSource/deleteByIds";
//     fetch(url, {
//         method: 'post',
//         cache: 'no-cache',
//         headers: {
//             ...headers,
//             "Content-Type" : 'application/json'
//         },
//         credentials: 'include',
//         body: JSON.stringify(ids)
//     }).then(response => response.json()).then(data => {
//         callBack(data);
//     }).catch((error) => {
//         console.error("actionError:linkSourceListInitDataSource",error);
//         callBack({});
//     })
// };